import $ from "cash-dom";
import {
  Chart,
  ArcElement,
  PointElement,
  DoughnutController,
  Tooltip,
} from "chart.js";
Chart.register(ArcElement, PointElement, DoughnutController, Tooltip);

const colors = [
  "#ADC4EB",
  "#132369",
  "#fCCf33",
  "#00C779",
  "#1B61DB",
  "#F44336",
  "#FC6DAB",
  "#E55934",
  "#6A3937",
];

async function getData() {
  const container = $("#emailFormatsChart");
  const id = container.data("company-id");
  if (!container.length || !/^\d+$/.test(String(id))) {
    return null;
  }
  const url = `${window.location.protocol}//${window.location.hostname}/companies/api/email-formats-chart/${id}`;
  const response = await fetch(url, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  });
  const data = await response.json();
  return data;
}
async function displayChart() {
  const data = await getData();
  if (!data) return;
  const container = $("#emailFormatsChart");
  const ctx = container.children("canvas").get(0).getContext("2d");
  new Chart(ctx, {
    type: "doughnut",
    weight: 10,
    data: {
      labels: Object.keys(data[0].formats),
      datasets: [
        {
          data: Object.values(data[0].formats),
          backgroundColor: colors,
          hoverOffset: 4,
        },
      ],
    },
    options: {
      cutout: "75%",
      plugins: {
        legend: {
          display: false,
        },
      },
    },
  });

  container.children("span.bulma-loader-mixin").remove();
  container.children().removeClass("is-hidden");
  if (data[1].logo) {
    container
      .children()
      .attr("style", `background-image: url(${data[1].logo})`);
  }
  syncItemsColor();
}

function syncItemsColor() {
  const dots = $(".email-formats .dot");
  dots.each((index, dot) => {
    let color = colors[index];
    $(dot).attr("style", `background-color: ${color}`);
  });

  const row = $(".email-formats__item");
  row.each((index, element) => {
    let color = colors[index];
    $(element).attr("style", `border-right: 4px solid ${color}`);
  });
}
displayChart();
